export const fetch = {
  props: {
    flexFlow: 'y',
    gap: 'C1',
    padding: 'D1',
    align: 'start'
  },
  state: {
    method: 'GET',
    type: 'state',
    headers: {},
    headersArr: [],
    params: {},
    paramsArr: [],
    auth: {},
    authArr: [],
    body: {},
    runtime: false,
    title: '',
    key: ''
  },
  GroupField: {
    width: '100%',
    Title: {
      text: '{{ editor.fetch.endpointUrl | polyglot }}'
    },
    Flex: {
      flow: 'x',
      align: 'stretch start',
      childProps: {
        borderRadius: 'Y',
        ':first-child': {
          borderRadius: 'Y 0 0 Y'
        },
        ':last-child': {
          borderRadius: '0 Y Y 0'
        }
      },
      SelectField: {
        Select: {
          theme: null,
          borderRadius: 'X2',
          Get: {
            text: 'Get',
            value: 'GET'
          },
          Post: {
            text: 'Post',
            value: 'POST'
          },
          Patch: {
            text: 'Patch',
            value: 'PATCH'
          },
          Update: {
            text: 'Update',
            value: 'UPDATE'
          },
          Delete: {
            text: 'Delete',
            value: 'DELETE'
          },
          onChange: (event, element, state) => {
            state.update({
              method: element.node.value
            })
            console.log(element.node.value)
          }
        }
      },
      VerticalLine: {
        margin: 0,
        background: 'line-highlight'
      },
      Input_endpointUrl: {
        flex: 1,
        paddingBlock: 'Z1',
        placeholder: (el) => el.call('polyglot', 'editor.fetch.routePlaceholder'),
        width: '400px',
        onInput: (event, element, state) => {
          state.quietUpdate({
            endpointUrl: element.node.value
          })
        }
      }
    }
  },
  Flex: {
    width: '100%',
    flow: 'y',
    gap: 'B2',
    childExtends: 'Flex',
    childProps: {
      flow: 'y',
      gap: 'Z2',
      align: 'start'
    },
    Params: {
      Flex: {
        flow: 'y',
        gap: 'Z2',
        align: 'start',
        hide: (el, s) => !s.paramsArr.length,
        Span: {
          color: 'paragraph',
          text: '{{ editor.fetch.params | polyglot }}'
        },
        Flex: {
          flow: 'y',
          gap: 'Z',
          childdisplay: 'flex',
          childProps: {
            gap: 'X2',
            align: 'center',
            // ——— the row-sync watcher (WS-DEAD-ONSTATEUPDATE-HOOKS-FETCH-DS-1) ———
            //
            // `onStateUpdate` is a DECLARATIVE effect in DOMQL v3.14: the
            // framework registers it ONLY when a sibling `stateDeps` ARRAY
            // exists, and no legacy `stateUpdate` event is emitted. This
            // block shipped with NO `stateDeps` and the legacy `(_, el, s)`
            // signature, so it never ran once — and it is the ONLY writer of
            // an edited row back into the request, so a typed paramsArr pair
            // never reached `paramsArr` / `params`.
            //
            // Deps (each self-contained — FA204): the row's own `key` and
            // `value`, the pair the debounced `onInput` above writes. The
            // handler writes to the PARENT state only, so it never re-enters.
            stateDeps: [(el, s) => (s || {}).key, (el, s) => (s || {}).value],
            // v3.14 signature: `(el, state, context, { prev, next })`.
            onStateUpdate: (el, s, ctx, { prev }) => {
              const page = s.parent
              if (!page) return
              const rows = page.paramsArr || []
              const prevKey = prev[0]
              const prevValue = prev[1]
              // `childKey = rawChild.key || index` (create.js), so `el.key`
              // is the PARAM NAME for every named row — an `el.key` index
              // write would put a string property on the array. Locate the
              // slot by the snapshot the row held BEFORE this edit.
              let index = -1
              for (let i = 0; i < rows.length; i++) {
                const row = rows[i]
                if (row && row.key === prevKey && row.value === prevValue) {
                  index = i
                  break
                }
              }
              if (index < 0) {
                const asIndex = parseInt(el.key, 10)
                index = Number.isInteger(asIndex) ? asIndex : -1
              }
              if (index > -1) rows[index] = s.parse()
              const { key, value } = s
              const map = page.params
              // A renamed key must not leave the old entry in the request.
              if (prevKey && prevKey !== key && map) delete map[prevKey]
              if (!key || !value) return
              // Write THROUGH the map store, never `quietUpdate({ params: … })`:
              // a store `update` merges only at the TOP level, so a nested
              // `{ params: { [key]: value } }` REPLACES the whole map and
              // erases every other row. A direct key write also skips the
              // parent re-render that would rebuild the rows and drop the
              // caret mid-typing.
              if (map) map[key] = value
              else page.quietUpdate({ params: { [key]: value } })
            },
            childProps: (el) => ({
              onInput: el.call(
                'debounce',
                (event, element, state) => {
                  state.update({
                    [element.key.split('_')[1]]: element.node.value
                  })
                },
                1000
              )
            }),
            Input_key: {
              padding: 'Z A',
              value: '{{ key }}',
              placeholder: (el) => el.call('polyglot', 'editor.fetch.paramKey')
            },
            Input_value: {
              padding: 'Z A',
              value: '{{ value }}',
              placeholder: (el) => el.call('polyglot', 'editor.fetch.paramValue')
            },
            IconButton: {
              icon: 'trash',
              onClick: (ev, el, s) => {
                s.parent.apply((s2) => {
                  delete s2.params[s2.key]
                  s2.paramsArr.splice(parseInt(el.parent.key, 10), 1)
                })
              }
            }
          },
          children: (el, s) => s.paramsArr,
          childrenAs: 'state'
        }
      },
      AddItemButton: {
        Caption: {
          text: '{{ editor.fetch.addParams | polyglot }}'
        },
        onClick: (ev, el, s) => {
          s.apply((s2) => {
            s2.paramsArr.push({})
          })
        }
      }
    },
    Auth: {
      Flex: {
        flow: 'y',
        gap: 'Z2',
        align: 'start',
        hide: (el, s) => !s.authArr.length,
        Span: {
          color: 'paragraph',
          text: '{{ editor.fetch.auth | polyglot }}'
        },
        Flex: {
          flow: 'y',
          gap: 'Z',
          childdisplay: 'flex',
          childProps: {
            gap: 'X2',
            align: 'center',
            // ——— the row-sync watcher (WS-DEAD-ONSTATEUPDATE-HOOKS-FETCH-DS-1) ———
            //
            // `onStateUpdate` is a DECLARATIVE effect in DOMQL v3.14: the
            // framework registers it ONLY when a sibling `stateDeps` ARRAY
            // exists, and no legacy `stateUpdate` event is emitted. This
            // block shipped with NO `stateDeps` and the legacy `(_, el, s)`
            // signature, so it never ran once — and it is the ONLY writer of
            // an edited row back into the request, so a typed authArr pair
            // never reached `authArr` / `auth`.
            //
            // Deps (each self-contained — FA204): the row's own `key` and
            // `value`, the pair the debounced `onInput` above writes. The
            // handler writes to the PARENT state only, so it never re-enters.
            stateDeps: [(el, s) => (s || {}).key, (el, s) => (s || {}).value],
            // v3.14 signature: `(el, state, context, { prev, next })`.
            onStateUpdate: (el, s, ctx, { prev }) => {
              const page = s.parent
              if (!page) return
              const rows = page.authArr || []
              const prevKey = prev[0]
              const prevValue = prev[1]
              // `childKey = rawChild.key || index` (create.js), so `el.key`
              // is the PARAM NAME for every named row — an `el.key` index
              // write would put a string property on the array. Locate the
              // slot by the snapshot the row held BEFORE this edit.
              let index = -1
              for (let i = 0; i < rows.length; i++) {
                const row = rows[i]
                if (row && row.key === prevKey && row.value === prevValue) {
                  index = i
                  break
                }
              }
              if (index < 0) {
                const asIndex = parseInt(el.key, 10)
                index = Number.isInteger(asIndex) ? asIndex : -1
              }
              if (index > -1) rows[index] = s.parse()
              const { key, value } = s
              const map = page.auth
              // A renamed key must not leave the old entry in the request.
              if (prevKey && prevKey !== key && map) delete map[prevKey]
              if (!key || !value) return
              // Write THROUGH the map store, never `quietUpdate({ auth: … })`:
              // a store `update` merges only at the TOP level, so a nested
              // `{ auth: { [key]: value } }` REPLACES the whole map and
              // erases every other row. A direct key write also skips the
              // parent re-render that would rebuild the rows and drop the
              // caret mid-typing.
              if (map) map[key] = value
              else page.quietUpdate({ auth: { [key]: value } })
            },
            childProps: (el) => ({
              onInput: el.call(
                'debounce',
                (event, element, state) => {
                  state.update({
                    [element.key.split('_')[1]]: element.node.value
                  })
                },
                1000
              )
            }),
            Input_key: {
              padding: 'Z A',
              value: '{{ key }}',
              placeholder: (el) => el.call('polyglot', 'editor.fetch.authKey')
            },
            Input_value: {
              padding: 'Z A',
              value: '{{ value }}',
              placeholder: (el) => el.call('polyglot', 'editor.fetch.authValue')
            },
            IconButton: {
              icon: 'trash',
              onClick: (ev, el, s) => {
                s.parent.apply((s2) => {
                  delete s2.auth[s2.key]
                  s2.authArr.splice(parseInt(el.parent.key, 10), 1)
                })
              }
            }
          },
          children: (el, s) => s.authArr,
          childrenAs: 'state'
        }
      },
      AddItemButton: {
        Caption: {
          text: '{{ editor.fetch.addAuth | polyglot }}'
        },
        onClick: (ev, el, s) => {
          s.apply((s2) => {
            s2.authArr.push({})
          })
        }
      }
    },
    Headers: {
      Flex: {
        flow: 'y',
        gap: 'Z2',
        align: 'start',
        hide: (el, s) => !s.headersArr.length,
        Span: {
          color: 'paragraph',
          text: '{{ editor.fetch.headers | polyglot }}'
        },
        Flex: {
          flow: 'y',
          gap: 'Z',
          childdisplay: 'flex',
          childProps: {
            gap: 'X2',
            align: 'center',
            // ——— the row-sync watcher (WS-DEAD-ONSTATEUPDATE-HOOKS-FETCH-DS-1) ———
            //
            // `onStateUpdate` is a DECLARATIVE effect in DOMQL v3.14: the
            // framework registers it ONLY when a sibling `stateDeps` ARRAY
            // exists, and no legacy `stateUpdate` event is emitted. This
            // block shipped with NO `stateDeps` and the legacy `(_, el, s)`
            // signature, so it never ran once — and it is the ONLY writer of
            // an edited row back into the request, so a typed headersArr pair
            // never reached `headersArr` / `headers`.
            //
            // Deps (each self-contained — FA204): the row's own `key` and
            // `value`, the pair the debounced `onInput` above writes. The
            // handler writes to the PARENT state only, so it never re-enters.
            stateDeps: [(el, s) => (s || {}).key, (el, s) => (s || {}).value],
            // v3.14 signature: `(el, state, context, { prev, next })`.
            onStateUpdate: (el, s, ctx, { prev }) => {
              const page = s.parent
              if (!page) return
              const rows = page.headersArr || []
              const prevKey = prev[0]
              const prevValue = prev[1]
              // `childKey = rawChild.key || index` (create.js), so `el.key`
              // is the PARAM NAME for every named row — an `el.key` index
              // write would put a string property on the array. Locate the
              // slot by the snapshot the row held BEFORE this edit.
              let index = -1
              for (let i = 0; i < rows.length; i++) {
                const row = rows[i]
                if (row && row.key === prevKey && row.value === prevValue) {
                  index = i
                  break
                }
              }
              if (index < 0) {
                const asIndex = parseInt(el.key, 10)
                index = Number.isInteger(asIndex) ? asIndex : -1
              }
              if (index > -1) rows[index] = s.parse()
              const { key, value } = s
              const map = page.headers
              // A renamed key must not leave the old entry in the request.
              if (prevKey && prevKey !== key && map) delete map[prevKey]
              if (!key || !value) return
              // Write THROUGH the map store, never `quietUpdate({ headers: … })`:
              // a store `update` merges only at the TOP level, so a nested
              // `{ headers: { [key]: value } }` REPLACES the whole map and
              // erases every other row. A direct key write also skips the
              // parent re-render that would rebuild the rows and drop the
              // caret mid-typing.
              if (map) map[key] = value
              else page.quietUpdate({ headers: { [key]: value } })
            },
            childProps: (el) => ({
              onInput: el.call(
                'debounce',
                (event, element, state) => {
                  state.update({
                    [element.key.split('_')[1]]: element.node.value
                  })
                },
                1000
              )
            }),
            Input_key: {
              padding: 'Z A',
              value: '{{ key }}',
              placeholder: (el) => el.call('polyglot', 'editor.fetch.headerKey')
            },
            Input_value: {
              padding: 'Z A',
              value: '{{ value }}',
              placeholder: (el) => el.call('polyglot', 'editor.fetch.headerValue')
            },
            IconButton: {
              icon: 'trash',
              onClick: (ev, el, s) => {
                s.parent.apply((s2) => {
                  delete s2.headers[s2.key]
                  s2.headersArr.splice(parseInt(el.parent.key, 10), 1)
                })
              }
            }
          },
          children: (el, s) => s.headersArr,
          childrenAs: 'state'
        }
      },
      AddItemButton: {
        Caption: {
          text: '{{ editor.fetch.addHeaders | polyglot }}'
        },
        onClick: (ev, el, s) => {
          s.apply((s2) => {
            s2.headersArr.push({})
          })
        }
      }
    },
    BodyParam: {
      if: (el, s) => ['post', 'update'].includes(s.method.toLowerCase()),
      flow: 'y',
      gap: 'X2',
      align: 'stretch',
      width: '100%',
      Span: {
        hide: (el, s) => !s.showBody,
        color: 'paragraph',
        text: '{{ editor.fetch.body | polyglot }}',
        width: '100%'
      },
      CodePreviewWidget: {
        hide: (el2, s2) => !s2.showBody,
        minWidth: '100%',
        widthRange: null,
        theme: 'field-static',
        round: 'X2',
        padding: 'X2 X2 X2 -',
        minHeight: 'G1',
        props: (el, s) => ({
          Monaco: {
            foldLevel: false,
            opacity: 1,
            fileTab: {
              code: el.call('stringifyCode', s.value, el, s),
              type: 'javascript',
              filename: 'function.js',
              fileTabKey: 'function'
            },
            onCodeEditCallback: async (editor) => {
              s.quietReplace({
                body: await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue())
              })
            }
          }
        })
      },
      AddItemButton: {
        IconButton: {
          icon: (el, s) => (s.showBody ? 'crossmark' : 'plus')
        },
        Caption: {
          text: (el, s) =>
            el.call('polyglot', s.showBody ? 'editor.fetch.removeBody' : 'editor.fetch.addBody')
        },
        onClick: (ev, el, s) => {
          s.apply((s2) => {
            s2.toggle('showBody')
          })
        }
      }
    }
  },
  ContinueButton: {
    alignSelf: 'start',
    text: '{{ editor.fetch.previewRequest | polyglot }}',
    onClick: async (ev, el, s) => {
      try {
        const response = await el.call('sendRequest', s.parse())
        console.log(response)
        s.update({ value: response })
      } catch (ex) {
        if (ex?.message) {
          return el.call('openNotification', {
            title: el.call('polyglot', 'editor.fetch.error'),
            message: ex.message,
            type: 'error'
          })
        }
      }
    }
  },
  CodePreviewWithTitle: {
    Line: {
      order: '-3',
      width: '100%'
    },
    width: '100%',
    maxWidth: '50vw',
    hide: (el, s) => !s.value,
    value: (el, s) => JSON.stringify(s.value),
    onUpdate: async (el, s) => {
      const code = el.call('stringifyCode', s.value)
      const value = await el.call('prettifyCode', code)
      return el.setProps({ value }, { preventUpdateListener: true })
    },
    CodePreview: {
      maxHeight: 'H+C1'
    }
  },
  Saving: {
    width: '100%',
    flexFlow: 'y',
    flexAlign: 'start start',
    gap: 'C1',
    hide: (el, s) => !s.value,
    Line: {
      order: '-3',
      width: '100%'
    },
    TitleField: {
      key: 'title',
      Title: {
        text: '{{ editor.fetch.stateTitle | polyglot }}'
      },
      Input: {
        placeholder: (el) => el.call('polyglot', 'editor.fetch.stateTitlePlaceholder')
      }
    },
    TitleField_key: {
      key: 'key',
      Title: {
        text: '{{ editor.fetch.stateKey | polyglot }}'
      },
      Input: {
        placeholder: (el) => el.call('polyglot', 'editor.fetch.stateKeyPlaceholder')
      }
    },
    SwitchFieldWithCaption: {
      Caption: {
        text: '{{ editor.fetch.runtime | polyglot }}'
      },
      onChange: (ev, el, s) => s.toggle('runtime')
    },
    CodePreviewWithTitle: {
      maxWidth: '50vw',
      show: (el, s) => s.runtime,
      value: (el) => el.call('codifyFetch')
    },
    SaveButton: {
      extends: 'ContinueButton',
      tag: 'button',
      alignSelf: 'start',
      type: 'submit',
      text: '{{ common.action.save | polyglot }}',
      onClick: async (ev, el, s) => {
        // if (runtime) {
        //   element.getRootState()[title] = resolve(data)
        // } else {
        // }
        // `message: `${ex}`` used to stand here in both branches — `ex` is a
        // catch binding belonging to a DIFFERENT handler further up this file
        // (the fetch-preview `catch (ex)`), never in scope here. ESM is strict
        // mode, so clicking Save with an empty key or value threw
        // `ReferenceError: ex is not defined` instead of showing the
        // validation notice. There is no exception to report in either branch;
        // the message states what is missing.
        if (!s.key)
          return el.call('openNotification', {
            title: el.call('polyglot', 'editor.fetch.keyRequired.title'),
            message: el.call('polyglot', 'editor.fetch.keyRequired.message'),
            type: 'error'
          })

        if (!s.value)
          return el.call('openNotification', {
            title: el.call('polyglot', 'editor.fetch.valueRequired.title'),
            message: el.call('polyglot', 'editor.fetch.valueRequired.message'),
            type: 'error'
          })

        const { runtime } = s
        if (runtime) {
          s.value = el.call('codifyFetch')
          console.log(s.value)
        }

        // `${key}` was a bare undeclared identifier here too — the entry's key
        // lives on this element's own state, which the guard above already
        // reads as `s.key`.
        const data = el.sdk.addItem(s.type, s.parse(), {
          message: `Added state section ${s.key}`
        })

        console.log(data)
      }
    }
  }
}
